// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionJ_TheComp__UBjBa"};